"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Check = _interopRequireDefault(require("../../Icons/Check"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

var _ThemeComponent = _interopRequireDefault(require("../../Theme/ThemeComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckBox = function CheckBox(_ref) {
  var children = _ref.children,
      id = _ref.id,
      group = _ref.group,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      checkIcon = _ref.checkIcon,
      ignoreBase = _ref.ignoreBase,
      variant = _ref.variant,
      otherProps = _objectWithoutProperties(_ref, ["children", "id", "group", "disabled", "onChange", "className", "defaultChecked", "checkIcon", "ignoreBase", "variant"]);

  return _react["default"].createElement(CheckWrapper, {
    variant: variant
  }, _react["default"].createElement(InputCheck, _extends({
    className: className,
    id: id,
    disabled: disabled,
    type: "checkbox",
    name: group,
    onChange: onChange,
    defaultChecked: defaultChecked,
    variant: variant
  }, otherProps)), _react["default"].createElement(Label, {
    htmlFor: id,
    variant: variant
  }, _react["default"].createElement(Icon, {
    variant: variant
  }), children));
};

CheckBox.themeProps = {
  wrapper: {
    name: "checkbox",
    description: "Checkbox style",
    type: _themeContants.themePropTypes.style
  },
  icon: {
    name: "checkbox_checked_icon",
    description: "Icon style",
    type: _themeContants.themePropTypes.style
  },
  iconComponent: {
    name: "COMPONENT_CHECKBOX_ICON",
    description: "Icon component",
    type: _themeContants.themePropTypes.component
  },
  label: {
    name: "checkbox_label",
    description: "Label style",
    type: _themeContants.themePropTypes.style
  },
  labelBefore: {
    name: "CHECKBOX_LABEL_BEFORE",
    description: "Label before style",
    type: _themeContants.themePropTypes.style
  },
  labelChecked: {
    name: "CHECKBOX_LABEL_CHECKED",
    description: "Label checked style",
    type: _themeContants.themePropTypes.style
  },
  labelBeforeChecked: {
    name: "CHECKBOX_LABEL_BEFORE_CHECKED",
    description: "Label before checked style",
    type: _themeContants.themePropTypes.style
  },
  input: {
    name: "checkbox_input",
    description: "Inputstyle",
    type: _themeContants.themePropTypes.style
  }
};

var CheckWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CheckBox__CheckWrapper",
  componentId: "sc-17r72qz-0"
})(["", ";"], (0, _theming.applyVariants)(CheckBox.themeProps.wrapper));

var IconComponent = function IconComponent(_ref2) {
  var props = _extends({}, _ref2);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: CheckBox.themeProps.iconComponent,
    fallback: _Check["default"]
  }, props));
};

var Icon = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "CheckBox__Icon",
  componentId: "sc-17r72qz-1"
})(["position:absolute;left:3px;top:15px;display:block;height:18px;width:18px;transform:scale(0);transition:all 0.2s ease-in-out;color:", ";", ";"], _theming.color.primary, (0, _theming.applyVariants)(CheckBox.themeProps.icon));
exports.Icon = Icon;

var InputCheck = _styledComponents["default"].input.withConfig({
  displayName: "CheckBox__InputCheck",
  componentId: "sc-17r72qz-2"
})(["position:absolute;clip:rect(0,0,0,0);clip:rect(0 0 0 0);&:checked ~ label{> svg{transform:scale(1);}", ";}&:checked ~ label::before{", ";}&:focus ~ label{&::before{border-color:", ";}}", ";"], (0, _theming.applyVariants)(CheckBox.themeProps.labelChecked), (0, _theming.applyVariants)(CheckBox.themeProps.labelBeforeChecked), _theming.color.primary, (0, _theming.applyVariants)(CheckBox.themeProps.input));

var Label = _styledComponents["default"].label.withConfig({
  displayName: "CheckBox__Label",
  componentId: "sc-17r72qz-3"
})(["padding:0 0 0 ", ";position:relative;font-weight:", ";letter-spacing:normal;width:auto;cursor:pointer;font-family:", ";font-size:", ";line-height:1.6;display:inline-block;min-height:", ";padding-top:", ";padding-bottom:", ";&::before{content:\"\";background:", ";border:1px solid ", ";border-radius:", ";display:block;height:", ";left:0;position:absolute;top:", ";width:", ";", ";}&:hover,&:focus{&::before{border-color:", ";}}", ";"], _theming.spacing.mediumPlus, _theming.fontWeight.normal, _theming.fontFamily.body, _theming.font.base, _theming.targetSize.normal, _theming.spacing.small, _theming.spacing.small, _theming.color.white, _theming.color.line, _theming.borderRadius, _theming.spacing.medium, _theming.spacing.small, _theming.spacing.medium, (0, _theming.applyVariants)(CheckBox.themeProps.labelBefore), _theming.color.primary, (0, _theming.applyVariants)(CheckBox.themeProps.label));

CheckBox.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  disabled: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  input: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  defaultChecked: _propTypes["default"].bool,
  checkIcon: _propTypes["default"].element,
  ignoreBase: _propTypes["default"].func
};
CheckBox.defaultProps = {
  disabled: false,
  input: {},
  onChange: null,
  className: "",
  defaultChecked: false,
  checkIcon: null
};
var _default = CheckBox;
exports["default"] = _default;